{
  "version": 1,
  "asset_id": "5c47fe16-2339-430b-a33e-f3e14b023db6",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/5c47fe16-2339-430b-a33e-f3e14b023db6/form-843.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/5c47fe16-2339-430b-a33e-f3e14b023db6/form-843.jpg",
  "original_filename": "form-843.jpg",
  "size": 172559,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:39:21Z"
}
